import { request } from '@/tools'

const fileServiceBase = '/prod-api/file'

// 获取OSS文件上传信息,返回有值则用前端直连，没有值走后端upload的api上传
const getOSSSignature = data => {
  if (!data) {
    // mino时需要传值
    data = {
      fileName: '',
      fileType: ''
    }
  }

  return request({
    url: `/ossSign`,
    baseUrl: fileServiceBase,
    method: 'post',
    data,
    opts: {
      showLoading: false
    }
  })
}

const uploadFileServiceUrl = fileServiceBase + '/upload'

const uploadFile = data => {
  return request({
    url: `/upload`,
    baseUrl: fileServiceBase,
    method: 'post',
    data,
    opts: {
      showLoading: false
    }
  })
}

export {
  getOSSSignature,
  uploadFile,
  uploadFileServiceUrl,
}



// WEBPACK FOOTER //
// ./src/service/file.js